import { render, staticRenderFns } from "./hierarchy-product-view.vue?vue&type=template&id=a982ec04&scoped=true"
import script from "./hierarchy-product-view.vue?vue&type=script&lang=js"
export * from "./hierarchy-product-view.vue?vue&type=script&lang=js"
import style0 from "./hierarchy-product-view.vue?vue&type=style&index=0&id=a982ec04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a982ec04",
  null
  
)

export default component.exports